import React from "react";
import { useDispatch } from "react-redux";
import "semantic-ui-css/semantic.min.css";
import { Checkbox, Dropdown } from "semantic-ui-react";
import { toggleInfoBpx } from "../../redux/infoBoxGeneral";
import { updateFilter } from "../../redux/sceneGlobal";
import { setZone, toggleWindRisk } from "../../redux/shadingSystem";
import "../NavBar.css";
import { useTheme } from "../../styles/themes/themeContext";

const DropDownShading = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  var inputData = props.inputData;

  const items = inputData.map(({ id, title, zone }) => (
    <Dropdown.Item
      key={id + title}
      onClick={() => {
        dispatch(toggleWindRisk(id));
        const filterPath = props.title
          ? `${props.parentTitle} >> ${props.title} >> ${title}`
          : `${props.parentTitle} >> ${title}`;
        dispatch(updateFilter([filterPath]));
        if (zone != null) {
          dispatch(setZone([zone]));
        }
      }}
    >
      <Checkbox checked={props.status.checkStatus[id]} label={title} key={id} />
      <button
        style={{ background: "none", border: "none" }}
        onClick={() => {
          dispatch(toggleInfoBpx([title]));
        }}
      >
        <i
          class="info circle icon"
          style={{ marginLeft: "5px", color: theme.primary }}
        ></i>
      </button>
    </Dropdown.Item>
  ));

  if (props.flat) {
    return <>{items}</>;
  }

  return (
    <Dropdown
      item
      simple
      text={props.title}
      title={props.title}
      className="drop-down truncate-label"
    >
      <Dropdown.Menu className="kkk">{items}</Dropdown.Menu>
    </Dropdown>
  );
};

export default DropDownShading;
